export default function number(value, locale, options = {}) {
  return Intl.NumberFormat(locale, options).format(value)
}
